import { render, staticRenderFns } from "./AmazonIcon.vue?vue&type=template&id=22ab2f47&"
import script from "./AmazonIcon.vue?vue&type=script&lang=js&"
export * from "./AmazonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports